import createVueComponent from '../createVueComponent';
export default createVueComponent('menu-2', 'IconMenu2', [
  ['path', { d: 'M4 6l16 0', key: 'svg-0' }],
  ['path', { d: 'M4 12l16 0', key: 'svg-1' }],
  ['path', { d: 'M4 18l16 0', key: 'svg-2' }],
]);
